import { useMediaQuery } from '@mui/material';

// TODO: use theme variables instead of hardcoded value after current variables are implemented in theme
export const useIsMobile = () => useMediaQuery('(max-width: 768px)');
